import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToDashboardPage = () => {
  const { navigation } = useNavigation()

  return <Navigate to={navigation.reports.dashboards.list.fullPath()} />
}

export default RedirectToDashboardPage
